import axios from "axios";

const URL = 'http://54.161.188.37:8083/fabrica';
//const URL = 'http://localhost:8083/fabrica';

const api = axios.create({
    baseURL: URL
});

export default api;